import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1rem',

    '&:hover': {
      '& .controls': {
        display: 'flex'
      }
    }
  },

  name: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '1rem',
    fontSize: theme.size.sm,

    '& .lock': {
      marginRight: '0.5rem',
      color: theme.palette.primary.main
    }
  },

  controls: {
    alignItems: 'center',
    cursor: 'pointer',
    color: theme.palette.textAlt,
    display: 'none',

    '& > :not(:last-child)': {
      marginRight: '0.25rem'
    }
  }
}))

export default useStyles
